import { CLOCK_COMMENT_REQUIRED_THRESHOLD_MINUTES } from './constants'
import type { WorkShiftClockAction } from './enums/work-shift-clock-action'

interface IsClockCommentRequiredInput {
  action: WorkShiftClockAction
  deltaMinutes: number | null
  hasTargetShift: boolean
}

export function isClockCommentRequired({
  action,
  deltaMinutes,
  hasTargetShift,
}: IsClockCommentRequiredInput): boolean {
  if (!hasTargetShift) return true
  if (deltaMinutes === null) return true

  const threshold = CLOCK_COMMENT_REQUIRED_THRESHOLD_MINUTES

  if (action === 'clock-in' && deltaMinutes > threshold) return true
  if (action === 'clock-out' && Math.abs(deltaMinutes) > threshold) return true

  return false
}
